<h4>Title insurance order</h4>
<table class="dashboard-table table-auto mt-10 max-w-4xl">
	<thead>
		<tr>
			<th>Item</th>
			<th>Premium/Fee</th>
			<th *ngIf="!separateTaxes">Tax</th>
			<th>Total</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let fee of fees">
			<td>{{ fee?.description | capitalize }}</td>
			<td>{{ fee.amount | centsToDollars }}</td>
			<td *ngIf="!separateTaxes">{{ fee?.tax | centsToDollars }}</td>
			<td>{{ fee?.total | centsToDollars }}</td>
		</tr>
		<tr>
			<td class="font-bold text-right">Total</td>
			<td class="font-bold">{{ totalAmount | centsToDollars }}</td>
			<td *ngIf="!separateTaxes">{{ totalTax | centsToDollars }}</td>
			<td class="font-bold">{{ total | centsToDollars }}</td>
		</tr>
		<tr *ngFor="let credit of credits">
			<td>({{ credit?.description }})</td>
			<td>({{ credit?.amount | centsToDollars }})</td>
			<td *ngIf="!separateTaxes">{{ credit?.tax | centsToDollars }}</td>
			<td>({{ credit?.total | centsToDollars }})</td>
		</tr>
	</tbody>
</table>

<div class="flex justify-between items-end mt-10">
	<app-button btn="tertiary" (click)="close()" size="small">Close</app-button>
	<div class="grid grid-cols-2 gap-2">
		<p *ngIf="separateTaxes" class="text-sm font-bold">Tax:</p>
		<p *ngIf="separateTaxes" class="text-sm ml-5">
			{{ totalTax | centsToDollars }}
		</p>
		<p class="text-sm font-bold">Premium:</p>
		<p class="text-sm ml-5">{{ afterCredit | centsToDollars }}</p>
	</div>
</div>
